module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAKlBMVEUAAAD///////////////////////////////////////////////////+Gu8ovAAAADnRSTlMAgDh4UBBwMBhYIAhIQEoaNhAAAACeSURBVAjXXc4xCsJAEIXhQRIFrX43bhQUTDrLbbRNKtt4AxcvoOgFtLeIJ8gRcgRLj+BxnEXS5FUfDPN40s84r/6IN440YHLz4E2rvAKr2J31yhbm4guRAVVG8uCotHIHmGkP33JZwlTfHBQRLJQ1vJVGmUFSJk8akQOENrcWGfKpSWOUkQ2HEzpoZKoM2IU5zoLdt6K5YF7d3LyRXn7DQxdGHuStMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/image/new/game/game-tab1.png
// module id = 3sAT
// module chunks = 1